import React, { useEffect, useState } from "react";
import {
  BLACK_SPCL_CHARS,
  BLACK_SPCL_CHARS_STR,
  CH_NAV_TYPE,
  customReactSelectMenuStyle,
  DATE_FORMAT_CLIENT,
  DATE_FORMAT_SERVER,
  initAlertConfig,
  LAT_ERR_MSG,
  LATPATTERN_5,
  LONG_ERR_MSG,
  LONGPATTERN_5,
  NAME_REGEX,
  NUMBER_NINE_DECIMAL,
  NUMBER_REGEX,
  PHONE_NUM,
  REQUIRED_ERR_MSG,
  TEXT_AREA_REGEX,
} from "../../Helper/Constants";
import Layout from "../../Layout/Layout";
import "./CharterBookingStyle.scss";
import { Button, ButtonGroup, Card, Col, Row } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import {
  CH_RATE_TYPE,
  CH_SRVC_TYPE,
  DELIVERY_SERVICE_ID,
  INFO_CODE,
  LINEHAUL_CUSTOMER_USER_TYPE_PERSONAL,
  ORDER_TYPE,
  PARTICULAR,
  PICKUP_SERVICE_ID,
  ROUTE_TYPE,
} from "../../../ConfigConstants/ConfigConstants";
import { CallApiGet, CallApiPost } from "../../Helper/serviceApi";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import {
  cleanNewLine,
  getKiplForm,
  numberInputOnWheelPreventChange,
  switchUserInfo,
} from "../../Helper/CommonMethods";
import GetSvgIcon from "../../../images/svglist";
import {
  initRateObj,
  initRouteData,
} from "../../CharteredRouteConfig/CharteredRoute/MultiRouteMain";
import Toggler from "../../Utilities/Toggler";
import Switch from "../../Utilities/Switch";
import { getUserInfo } from "../../AuthUtils/AuthUtils";
import BookingInsurance from "../StandardBooking/BookingInsurance";
import CharterOrderSummary from "./CharterOrderSummary";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URI } from "../../../ConfigConstants/UrlConstants";

import MapPin2 from "../../../images/MAP-PIN-2.png";
import { Tooltip } from "react-tooltip";
import LocateSBU from "../StandardBooking/LocateSBU";
import { useDistanceMatrix } from "../../Utilities/useDistanceMatrix";
const addrLabel = {
  org: { label: "Origin", pKey: "route", sKey: "origin" },
  dest: { label: "Destination", pKey: "route", sKey: "destination" },
};

const initStateCityOpt = {
  "route.originStateArr": [],
  "route.originCityArr": [],
  "route.destinationStateArr": [],
  "route.destinationCityArr": [],
  loadedStateArry: [],
  loadedCityArry: [],
};

const toggleBtn = {
  checkedBtn: {
    variant: "primary",
    className: "theme-violet text-nowrap",
    checked: true,
  },
  unCheckedBtn: {
    variant: "secondary",
    className: "text-nowrap",
    checked: false,
  },
};

const P_CHARTER = "PLANNED CHARTER";
const A_CHARTER = "ON-DEMAND CHARTER";

const initRate = {
  rateType: [],
  defaultRateType: [],
  rateOpts: [],
  vhclTypeOpts: [],
  defaultRateOpts: [],
  defaultVhclTypeOpts: [],
};

const initItem = {
  stopSeq: 0,
  infoCode: INFO_CODE.CH,
  infoValue: "",
  infoType: "",
  infoQuantity: "",
};

const CharteredBooking = () => {
  const location = useLocation();
  const navData = location.state;
  const [bkngDateRange, setBkngDateRange] = useState({
    minChDate: moment().utcOffset("+08:00").add(0, "d"),
    maxChDate: moment().utcOffset("+08:00").add(8, "d"),
  });
  const [spinner, setSpinner] = useState(false);
  const [alertConfig, setAlertConfig] = useState(initAlertConfig);
  const [routes, setRoutes] = useState([]);
  const [rate, setRate] = useState(Object.assign({}, initRate));
  const [insuranceData, setInsuranceData] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [avalServices, setAvalServices] = useState([
    ...[
      {
        value: PICKUP_SERVICE_ID,
        label: "Pick up",
        isChecked: true,
      },
    ],
    ...[
      {
        value: DELIVERY_SERVICE_ID,
        label: "Delivery",
        isChecked: true,
      },
    ],
  ]);
  const navigate = useNavigate();

  const [stateCityOpt, setStateCityOpt] = useState(
    Object.assign({}, initStateCityOpt)
  );
  const [geofence, setGeofence] = useState([]);
  const [isLoaded, setLoaded] = useState(false);
  const [custCreditInfo, setCustCreditInfo] = useState();
  const [showMap, setShowMap] = useState({ show: false, data: {} });
  const { calculateDistance } = useDistanceMatrix();
  const { customerId } = location.state || {};
  const {
    register,
    control,
    watch,
    reset,
    setValue,
    setError,
    clearErrors,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm();

  let pickUpDt = moment(watch("shipmentDate"));
  let estDlvDt = !!watch("estDeliveryDate")
    ? moment(watch("estDeliveryDate"))
    : "";

  const {
    register: summary,
    getValues: summaryGetValues,
    setValue: summarySetValue,
    reset: summaryReset,
    watch: summaryWatch,
  } = useForm();

  const { fields: rateArr, replace } = useFieldArray({
    control,
    name: "rate",
  });

  const {
    fields: orderInfos,
    replace: ordInfoReplace,
    append: ordInfoAppend,
    remove: ordInfoRemove,
  } = useFieldArray({
    control,
    name: "orderInfos",
  });

  useEffect(() => {
    initialize();
  }, []);

  useEffect(() => {
    if (tabIndex === 3) {
      navigateToPayment();
    }
  }, [tabIndex]);

  const getRateForRepeatBooking = (argRate) => {
    const preFillData = location.state;
    const resultRate = argRate.reduce(
      (acc, rt) => {
        switch (rt?.serviceId) {
          case CH_SRVC_TYPE.PIECES:
            return acc.some(
              (obj) =>
                obj.serviceId === CH_SRVC_TYPE.PIECES &&
                obj.unitType === rt.unitType
            )
              ? acc
              : [...acc, rt];
          case CH_SRVC_TYPE.VHCLTYPE:
          case CH_SRVC_TYPE.OTHERCHRG:
            return acc.some(
              (obj) =>
                [CH_SRVC_TYPE.VHCLTYPE, CH_SRVC_TYPE.OTHERCHRG].includes(
                  obj.serviceId
                ) && obj.rateRefId === rt.rateRefId
            )
              ? acc
              : [...acc, rt];
          default:
            return acc.some((obj) => obj.serviceId === rt.serviceId)
              ? acc
              : [...acc, rt];
        }
      },
      [...preFillData?.bkngData?.rateData]
    );
    return resultRate;
  };

  const initialize = () => {
    //1 day ahead booking should be allowed for chartered booking, 0 is added only for testing purpose
    setValue("shipmentTime", navData?.bkngData?.shipmentTime);
    const acctId = switchUserInfo(navData);
    const rateCustURI = `${API_URI.GET_CUST_CH_RATE_CONFIG}/${acctId}`;
    Promise.all([
      fetchRouteList(),
      fetchStatesAndCityList(),
      CallApiPost(API_URI.SYS_OPTION_BY_CODE, [
        "CH_RATE_TYPE",
        "CH_DT_LB",
        "CH_DT_UB",
      ]),
      CallApiGet(rateCustURI),
      CallApiGet("CharteredOptionValue"),
      CallApiGet("getAllVhclTypes?isCharter=true"),
      CallApiGet("getInsuranceData"),
      CallApiGet(
        `${API_URI.GET_CUST_CREDIT_INFO}?argProfileId=${
          !!customerId && +customerId > 0 ? customerId : 0
        }`
      ),
    ]).then(
      ([
        route,
        stateCity,
        rateTypeResp,
        rateCust,
        rateDefault,
        vhclType,
        insDataResp,
        custCredInfo,
      ]) => {
        let copyRate = Object.assign({}, initRate);
        if (rateTypeResp.respCode === 0 && !!rateTypeResp.respData) {
          copyRate.defaultRateType = rateTypeResp.respData?.filter(
            (so) => so.optionCode === "CH_RATE_TYPE"
          );
          const dtlb = rateTypeResp.respData?.find(
            (so) => so.optionCode === "CH_DT_LB"
          )?.optionValue;
          const dtub = rateTypeResp.respData.find(
            (so) => so.optionCode === "CH_DT_UB"
          )?.optionValue;
          setBkngDateRange({
            minChDate: moment().utcOffset("+08:00").add(+dtlb, "d"),
            maxChDate: moment().utcOffset("+08:00").add(+dtub, "d"),
          });
          // setValue(
          //   "shipmentDate",
          //   moment()
          //     .utcOffset("+08:00")
          //     .add(+dtlb, "d")
          //     .format(DATE_FORMAT_SERVER)
          // );
          // setValue(
          //   "estDeliveryDate",
          //   moment().utcOffset("+08:00").add(+dtub, "d")
          // );
        }
        if (
          rateCust.respCode === 200 &&
          !!rateCust.respData &&
          Array.isArray(rateCust.respData) &&
          rateCust.respData.length > 0
        ) {
          copyRate.rateOpts = rateCust.respData[0].rate.filter(
            (rt) =>
              rt.serviceId !== CH_SRVC_TYPE.VHCLTYPE &&
              rt.serviceId !== CH_SRVC_TYPE.STOPCHG
          );
          copyRate.vhclTypeOpts = rateCust.respData[0].rate
            .filter((rt) => rt.serviceId === CH_SRVC_TYPE.VHCLTYPE)
            .map((rt) => {
              rt.label = rt.rateRefName;
              rt.value = rt.rateRefId;
              return rt;
            });
        } else {
          copyRate.rateOpts = [];
          copyRate.vhclTypeOpts = [];
        }
        let serviceArr = [];
        // copyRate.rateOpts.forEach((rt) => {
        //   if (rt.serviceUnitPrice > 0) {
        //     switch (rt.serviceId) {
        //       case CH_SRVC_TYPE.WEIGHT:
        //         serviceArr.push(CH_RATE_TYPE.WGT);
        //         break;
        //       case CH_SRVC_TYPE.PIECES:
        //         serviceArr.push(CH_RATE_TYPE.PCS);
        //         break;
        //       default:
        //         break;
        //     }
        //   }
        // });
        const isPcsExists = copyRate.rateOpts.some(
          (pcs) =>
            pcs.serviceId === CH_SRVC_TYPE.PIECES && pcs.serviceUnitPrice > 0
        );
        const isWgtExists = copyRate.rateOpts.some(
          (wgt) =>
            wgt.serviceId === CH_SRVC_TYPE.WEIGHT && wgt.serviceUnitPrice > 0
        );
        const isVhclTypeExists = copyRate.vhclTypeOpts.some(
          (vt) => vt.serviceUnitPrice > 0
        );
        if (isVhclTypeExists) {
          serviceArr.push(CH_RATE_TYPE.VT);
        }
        if (isPcsExists) {
          serviceArr.push(CH_RATE_TYPE.PCS);
        }
        if (isWgtExists) {
          serviceArr.push(CH_RATE_TYPE.WGT);
        }
        copyRate.rateType = copyRate.defaultRateType.filter((drt) =>
          serviceArr.includes(drt.value)
        );
        if (rateDefault.respCode === 200 && !!rateDefault.respData) {
          copyRate.defaultRateOpts = rateDefault.respData;
        } else {
          copyRate.defaultRateOpts = [];
        }

        if (vhclType.respCode === 200 && !!vhclType.respData) {
          copyRate.defaultVhclTypeOpts = vhclType.respData;
        }
        setRate(copyRate);

        if (insDataResp.respCode === 200) {
          setInsuranceData(insDataResp.respData.insuranceData);
        }
        if (custCredInfo.respCode === 200 || custCredInfo.respCode === 0) {
          setCustCreditInfo(custCredInfo.respData[0]);
        }
        setLoaded(true);
        let chOrderType = ORDER_TYPE.CHP;
        if (navData?.navigateFor === CH_NAV_TYPE.RB) {
          copyRate.rateOpts = getRateForRepeatBooking(
            navData?.bkngData?.orderType === ORDER_TYPE.CHP
              ? copyRate.rateOpts
              : copyRate.defaultRateOpts
          );
          setValue("insurancePkgId", navData?.bkngData?.insurancePkgId);
          const vhclTypeRB = navData?.bkngData?.rateData.find(
            (rt) => rt.serviceId === CH_SRVC_TYPE.VHCLTYPE
          );
          if (!!vhclTypeRB) {
            vhclTypeRB.label = vhclTypeRB?.rateRefName;
            vhclTypeRB.value = vhclTypeRB?.rateRefId;
            setValue("vhclTypeRate", vhclTypeRB);
            setValue("vhclType", vhclTypeRB?.rateRefId);
          }

          chOrderType = navData?.bkngData?.orderType;
        }
        onToggle(
          chOrderType,
          route,
          stateCity,
          copyRate,
          navData?.bkngData?.orderInfos?.filter(
            (info) => info.infoCode === INFO_CODE.CH
          )
        );
      }
    );
  };

  const watchPrimary = watch("primaryBtn");
  const watchSecondary = watch("secondaryBtn");
  const watchPageLabel = watch("pageLabel");
  const watchOrdType = watch("orderType");
  const watchRoute = watch("route");
  const watchStops = watch("route.stops");
  const watchRateType = watch("route.rateType");
  const watchRateTypeOpts = watch("rateTypeOpts");

  const handleApiResponse = (resp, argTerm = "NOAXN") => {
    switch (resp.respCode) {
      case 200:
        openAlert(true, "SUCCESS", resp.respMessage, argTerm);

        break;
      case 500:
        openAlert(
          false,
          "ERROR",
          "Something went wrong. Please try after sometime!!"
        );
        break;
      case 99:
        openAlert(false, "ERROR", "Network Error!!");
        break;
      default:
        openAlert(false, "ERROR", resp.respMessage);
        break;
    }
  };

  // This function will dynamically add state and city options for stops
  // As it is unknown how many stops will be there we are dynamically adding opts
  const addStateCityOpt = (noOfStops, argStateCity) => {
    let locStateCityOpt = !!argStateCity
      ? JSON.parse(JSON.stringify(argStateCity))
      : JSON.parse(JSON.stringify(stateCityOpt));
    for (let index = 0; index < noOfStops; index++) {
      locStateCityOpt[`route.stops.${index}StateArr`] =
        locStateCityOpt.loadedStateArry;
      locStateCityOpt[`route.stops.${index}CityArr`] =
        locStateCityOpt.loadedCityArry;
    }
    setStateCityOpt({ ...locStateCityOpt });
  };

  const setUpRouteData = (argData, argStateCity) => {
    let itemInfo = [];
    argData.origin =
      typeof argData?.origin === "string"
        ? JSON.parse(argData?.origin)
        : argData?.origin;

    argData.destination =
      typeof argData?.destination === "string"
        ? JSON.parse(argData?.destination)
        : argData?.destination;

    if (!!argData?.stops && argData?.stops.length > 0) {
      let tempStops =
        typeof argData?.stops === "string"
          ? JSON.parse(argData?.stops)
          : argData?.stops;
      argData.stops = !!tempStops[0] ? [...tempStops] : [];
      // argData.stops.forEach((st, index) =>
      //   itemInfo.push({ ...initItem, stopSeq: index + 1 })
      // );
    } else {
      argData.stops = [];
    }
    // itemInfo.push({ ...initItem, stopSeq: 99 });
    // setValue("itemInfo", [...itemInfo]);
    setValue("route", { ...argData });
    addStateCityOpt(argData?.stops?.length, argStateCity);
    return argData;
  };

  const fetchRouteList = async () => {
    let retData;
    setSpinner(true);
    // const custId = getUserInfo("customerId");
    let custId = switchUserInfo(navData);
    const uri = API_URI.DYN_ROUTE + "?custId=" + custId;
    const resp = await CallApiGet(uri);
    if (
      resp?.respCode === 200 &&
      !!resp?.respData &&
      Array.isArray(resp?.respData)
    ) {
      const routeList = resp?.respData?.filter((rt) => rt.active === true);
      setRoutes(routeList);
      retData =
        navData?.navigateFor === CH_NAV_TYPE.RB
          ? navData?.bkngData?.route
          : routeList.length > 0
          ? routeList[0]
          : null;
    } else {
      if (resp.respCode === 200) {
        resp.respCode = 409;
        resp.respMessage =
          "Sorry, failed to load Route List. Please try after sometime!!";
      }
      retData = null;
      handleApiResponse(resp);
    }
    setSpinner(false);
    return retData;
  };

  const fetchStatesAndCityList = async () => {
    let locStateCityOpt = Object.assign({}, initStateCityOpt);
    let data = await CallApiGet("getStateAndCityList");
    let cityArr = [];
    let stateArr = [];
    if (data.respCode === 200 || data.respCode === 0) {
      setGeofence(data.respData);
      let cityObj = {};
      let stateObj = {};

      data.respData.forEach((element) => {
        cityObj = {
          label: element.map_city,
          value: element.map_city,
        };
        if (!cityArr.some((city) => city.value === cityObj.value)) {
          cityArr.push(cityObj);
        }
        if (
          !locStateCityOpt[`route.originCityArr`].some(
            (obj) => obj.value === element.map_city
          )
        ) {
          locStateCityOpt[`route.originCityArr`].push(cityObj);
          locStateCityOpt[`route.destinationCityArr`].push(cityObj);
        }

        stateObj = {
          label: element.map_state,
          value: element.map_state,
        };
        if (!stateArr.some((state) => state.value === stateObj.value)) {
          stateArr.push(stateObj);
        }
        if (
          !locStateCityOpt[`route.originStateArr`].some(
            (obj) => obj.value === element.map_state
          )
        ) {
          locStateCityOpt[`route.originStateArr`].push(stateObj);
          locStateCityOpt[`route.destinationStateArr`].push(stateObj);
        }
      });
    } else {
      handleApiResponse(data);
    }
    locStateCityOpt.loadedCityArry = Array.from(cityArr, (c) => c);
    locStateCityOpt.loadedStateArry = Array.from(stateArr, (s) => s);
    setStateCityOpt(locStateCityOpt);
    // setDefaultStateCityOpt(Object.assign({}, locStateCityOpt));
    return locStateCityOpt;
  };

  const openAlert = (boolVal, argTitle, argDesc, argTerm = "NOAXN") => {
    setAlertConfig({
      isSuccess: boolVal,
      size: "",
      show: true,
      title: argTitle,
      description: argDesc,
      term: argTerm,
    });
  };

  const callback = (argTerm) => {
    switch (argTerm) {
      case "SCBKG":
        navigate(`/charteredOrders`);
        break;
      case "BKNG":
        proceedForBooking();
        break;
      default:
        break;
    }
  };

  const hideAlert = () => {
    callback(alertConfig.term);
    setAlertConfig({
      isSuccess: alertConfig.isSuccess,
      size: alertConfig.size,
      show: false,
      title: "",
      description: "",
    });
  };

  const onToggle = (
    argOrdType,
    argRoute,
    argStateCity,
    argRate,
    argOrdInfo = [{ ...initItem }]
  ) => {
    clearErrors();
    // setValue("rateType", 0);
    ordInfoReplace([...argOrdInfo]);
    switch (argOrdType) {
      case ORDER_TYPE.CHP:
        setValue("primaryBtn", toggleBtn.checkedBtn);
        setValue("secondaryBtn", toggleBtn.unCheckedBtn);
        setValue("orderType", ORDER_TYPE.CHP);
        setValue("pageLabel", P_CHARTER);
        setValue("vhclTypeOpts", argRate?.vhclTypeOpts);
        setValue("rateTypeOpts", argRate?.rateType);
        replace(argRate?.rateOpts);
        break;
      case ORDER_TYPE.CHA:
        setValue("primaryBtn", toggleBtn.unCheckedBtn);
        setValue("secondaryBtn", toggleBtn.checkedBtn);
        setValue("orderType", ORDER_TYPE.CHA);
        setValue("pageLabel", A_CHARTER);
        setValue("vhclTypeOpts", argRate?.defaultVhclTypeOpts);
        setValue("rateTypeOpts", argRate?.defaultRateType);
        replace(
          navData?.navigateFor === CH_NAV_TYPE.RB
            ? argRate?.rateOpts
            : argRate?.defaultRateOpts.filter(
                (rt) => rt.serviceId !== CH_SRVC_TYPE.VHCLTYPE
              )
        );
        break;
      default:
        break;
    }
    if (!!argRoute) {
      const revRouteData = setUpRouteData(
        JSON.parse(JSON.stringify(argRoute)),
        argStateCity
      );
      // addStateCityOpt(revRouteData?.stops?.length, argStateCity);
    }
  };

  const setCitiesForState = (key, argState) => {
    let cities = [];
    if (!!argState) {
      cities = geofence
        .filter((obj) => obj.map_state === argState)
        .map((obj) => ({ label: obj.map_city, value: obj.map_city }));
    } else {
      cities = stateCityOpt.loadedCityArry;
    }
    setStateCityOpt({ ...stateCityOpt, [key]: cities });
  };

  const setStateForCity = (key, argCity) => {
    let states = [];
    if (!!argCity) {
      states = geofence
        .filter((obj) => obj.map_city === argCity)
        .map((obj) => ({ label: obj.map_state, value: obj.map_state }));
    } else {
      states = stateCityOpt.loadedStateArry;
    }
    setStateCityOpt({ ...stateCityOpt, [key]: states });
    return states;
  };

  const updateState = (key, opt) => {
    if (!!opt) {
      setValue(key, opt.value);
      let newStateArr = setStateForCity(key, opt.value);
      setValue(key, newStateArr[0].value);
    } else {
      setValue(key, "");
      setStateForCity(key, null);
    }
  };

  const handleLocationSelect = (location) => {
    const { addressKey, addressSecKey, addressIndex, isArray } = showMap.data;
    let fieldPrefix = addressKey;

    // If this is an array item (like stops), and we have an index
    if (isArray && addressIndex !== null && addressIndex !== undefined) {
      fieldPrefix = `${addressKey}.${addressSecKey}.${addressIndex}`;
    } else {
      fieldPrefix = `${addressKey}.${addressSecKey}`;
    }

    // setValue(`${fieldPrefix}.address`, location?.address || "");
    // setValue(`${fieldPrefix}.city`, location?.city || "");
    // setValue(`${fieldPrefix}.state`, location?.state || "");
    // setValue(`${fieldPrefix}.postcode`, location?.postalCode || "");
    setValue(`${fieldPrefix}.latitude`, location?.location?.lat || "");
    setValue(`${fieldPrefix}.longitude`, location?.location?.lng || "");
  };

  const handleOnToggle = (checked, key, secKey, index) => {
    setValue(
      index >= 0
        ? `${key}.${secKey}.${index}.isChecked`
        : `${key}.${secKey}.isChecked`,
      checked,
      {
        shouldDirty: true,
      }
    );
    if (
      index >= 0
        ? !!errors?.[key]?.[secKey]?.[index] && !checked
        : !!errors?.[key]?.[secKey] && !checked
    ) {
      clearErrors(
        index >= 0 ? `${key}.${secKey}.${index}` : `${key}.${secKey}`
      );
    }
  };

  const addrBlock = (
    key,
    secKey,
    value,
    itemKey,
    index,
    isRequired,
    isArray
  ) => (
    <div key={itemKey} className="border-container w-100">
      {![0, 99].includes(itemKey) && (
        <div className=" border-check theme-label  fw-bold font-18">
          <div className="pe-0 ">
            {/* <input
              class="form-check-input p-0"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
              checked={watch(
                isArray
                  ? `${key}.${secKey}.${index}.isChecked`
                  : `${key}.${secKey}.isChecked`
              )}
              onChange={(e) =>
                handleOnToggle(e, key, secKey, isArray ? index : -1)
              }
            /> */}
            <Switch
              onText="GO"
              offText="NOGO"
              isOn={watch(
                isArray
                  ? `${key}.${secKey}.${index}.isChecked`
                  : `${key}.${secKey}.isChecked`
              )}
              keyCode={
                isArray
                  ? `${key}.${secKey}.${index}.isChecked`
                  : `${key}.${secKey}.isChecked`
              }
              width={70}
              height={25}
              onToggle={(k, v) =>
                handleOnToggle(v, key, secKey, isArray ? index : -1)
              }
            />
          </div>
        </div>
      )}
      <div className="border-text theme-label  fw-bold font-18">{value}</div>
      {watchOrdType === ORDER_TYPE.CHA && (
        <div className="border-map theme-label  fw-bold font-18">
          <label
            className="col-md-2 text-end p-0 m-0"
            onClick={() =>
              setShowMap({
                show: true,
                data: {
                  serviceType: "CB",
                  addressData: {
                    fullAddress: [
                      getValues(
                        `${key}.${secKey}${isArray ? `.${index}` : ""}.address`
                      ),
                      getValues(
                        `${key}.${secKey}${isArray ? `.${index}` : ""}.city`
                      ),
                      getValues(
                        `${key}.${secKey}${isArray ? `.${index}` : ""}.state`
                      ),
                      getValues(
                        `${key}.${secKey}${isArray ? `.${index}` : ""}.postcode`
                      ),
                    ]
                      .filter(Boolean)
                      .join(", "),
                    latLng: {
                      lat:
                        parseFloat(
                          getValues(
                            `${key}.${secKey}${
                              isArray ? `.${index}` : ""
                            }.latitude`
                          )
                        ) || null,
                      lng:
                        parseFloat(
                          getValues(
                            `${key}.${secKey}${
                              isArray ? `.${index}` : ""
                            }.longitude`
                          )
                        ) || null,
                    },
                  },
                  addressKey: key,
                  addressSecKey: secKey,
                  addressIndex: index,
                  isArray: isArray,
                },
              })
            }
          >
            <img
              alt="Map Icon"
              className="cursor-pointer text-end"
              data-tooltip-id={`map-p-${key}-${index}`}
              data-tooltip-content="Open Map"
              src={MapPin2}
              height="26px"
              width="26px"
            />
            <Tooltip
              id={`map-p-${key}-${index}`}
              effect={"solid"}
              className="map-p-tooltip"
            />
          </label>
        </div>
      )}
      <Row>
        <Col>
          <label className="form-label theme-label">
            Address
            {isRequired && <span className="text-danger">&#9733;</span>}
          </label>
          <textarea
            className="form-control"
            type="text"
            {...register(
              isArray
                ? `${key}.${secKey}.${index}.address`
                : `${key}.${secKey}.address`,
              {
                required: {
                  value:
                    isRequired ||
                    watch(
                      isArray
                        ? `${key}.${secKey}.${index}.isChecked`
                        : `${key}.${secKey}.isChecked`
                    ) === true,
                  message: REQUIRED_ERR_MSG,
                },
                validate: (v) =>
                  BLACK_SPCL_CHARS.test(v)
                    ? `Please check for invalid characters ${BLACK_SPCL_CHARS_STR}`
                    : true,
                setValueAs: (v) => cleanNewLine(v),
              }
            )}
            maxLength={500}
            disabled={
              watchOrdType === ORDER_TYPE.CHP ||
              watch(
                isArray
                  ? `${key}.${secKey}.${index}.isChecked`
                  : `${key}.${secKey}.isChecked`
              ) === false
            }
          />

          {(isArray && errors?.[key] && errors?.[key]?.[secKey]
            ? errors?.[key]?.[secKey][index]?.address
            : errors?.[key]?.[secKey]?.address) && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888;{" "}
                {isArray
                  ? errors?.[key]?.[secKey][index]?.address?.message
                  : errors?.[key]?.[secKey]?.address?.message}
              </span>
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <label className="form-label theme-label">
            City {isRequired && <span className="text-danger">&#9733;</span>}{" "}
          </label>
          <Controller
            name={
              isArray
                ? `${key}.${secKey}.${index}.city`
                : `${key}.${secKey}.city`
            }
            control={control}
            rules={{
              required: {
                value:
                  isRequired ||
                  watch(
                    isArray
                      ? `${key}.${secKey}.${index}.isChecked`
                      : `${key}.${secKey}.isChecked`
                  ) === true,
                message: REQUIRED_ERR_MSG,
              },
              min: { value: 1, message: REQUIRED_ERR_MSG },
            }}
            render={({ field: { onChange, value } }) => (
              <Select
                options={
                  stateCityOpt?.[
                    isArray
                      ? `${key}.${secKey}.${index}CityArr`
                      : `${key}.${secKey}CityArr`
                  ]
                }
                value={
                  stateCityOpt?.[
                    isArray
                      ? `${key}.${secKey}.${index}CityArr`
                      : `${key}.${secKey}CityArr`
                  ]?.find((el) => el.value === value) || ""
                }
                onChange={
                  (opt) => {
                    onChange(!!opt ? opt.value : opt);
                    updateState(
                      isArray
                        ? `${key}.${secKey}.${index}StateArr`
                        : `${key}.${secKey}StateArr`,
                      opt
                    );
                  }
                  // !!opt ? onChange(opt.value) : onChange(0)
                }
                placeholder="Select City"
                isSearchable={true}
                isClearable={true}
                className="form-control p-0"
                menuPortalTarget={document.body}
                styles={customReactSelectMenuStyle}
                isDisabled={
                  watchOrdType === ORDER_TYPE.CHP ||
                  watch(
                    isArray
                      ? `${key}.${secKey}.${index}.isChecked`
                      : `${key}.${secKey}.isChecked`
                  ) === false
                }
              />
            )}
          />
          {(isArray && errors?.[key] && errors?.[key]?.[secKey]
            ? errors?.[key]?.[secKey][index]?.city
            : errors?.[key]?.[secKey]?.city) && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888;{" "}
                {isArray
                  ? errors?.[key]?.[secKey][index]?.city?.message
                  : errors?.[key]?.[secKey]?.city?.message}
              </span>
            </div>
          )}
        </Col>
        <Col>
          <label className="form-label theme-label">
            State
            {isRequired && <span className="text-danger">&#9733;</span>}
          </label>
          <Controller
            name={
              isArray
                ? `${key}.${secKey}.${index}.state`
                : `${key}.${secKey}.state`
            }
            control={control}
            rules={{
              required: {
                value:
                  isRequired ||
                  watch(
                    isArray
                      ? `${key}.${secKey}.${index}.isChecked`
                      : `${key}.${secKey}.isChecked`
                  ) === true,
                message: REQUIRED_ERR_MSG,
              },
              min: { value: 1, message: REQUIRED_ERR_MSG },
            }}
            render={({ field: { onChange, value } }) => (
              <Select
                options={
                  stateCityOpt?.[
                    isArray
                      ? `${key}.${secKey}.${index}StateArr`
                      : `${key}.${secKey}StateArr`
                  ]
                }
                value={
                  stateCityOpt?.[
                    isArray
                      ? `${key}.${secKey}.${index}StateArr`
                      : `${key}.${secKey}StateArr`
                  ]?.find((el) => el.value === value) || ""
                }
                onChange={
                  (opt) => {
                    onChange(!!opt ? opt.value : opt);
                    if (!!opt) {
                      setCitiesForState(
                        isArray
                          ? `${key}.${secKey}.${index}CityArr`
                          : `${key}.${secKey}CityArr`,
                        opt.value
                      );
                    } else {
                      setCitiesForState(
                        isArray
                          ? `${key}.${secKey}.${index}CityArr`
                          : `${key}.${secKey}CityArr`,
                        null
                      );
                    }
                  }
                  // !!opt ? onChange(opt.value) : onChange(0)
                }
                placeholder="Select State"
                isSearchable={true}
                isClearable={true}
                isDisabled={
                  watchOrdType === ORDER_TYPE.CHP ||
                  watch(
                    isArray
                      ? `${key}.${secKey}.${index}.isChecked`
                      : `${key}.${secKey}.isChecked`
                  ) === false
                }
                className="form-control p-0"
                menuPortalTarget={document.body}
                styles={customReactSelectMenuStyle}
              />
            )}
          />
          {(isArray && errors?.[key] && errors?.[key]?.[secKey]
            ? errors?.[key]?.[secKey][index]?.state
            : errors?.[key]?.[secKey]?.state) && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888;{" "}
                {isArray
                  ? errors?.[key]?.[secKey][index]?.state?.message
                  : errors?.[key]?.[secKey]?.state?.message}
              </span>
            </div>
          )}
        </Col>
        <Col>
          <label className="form-label theme-label">
            Postcode
            {isRequired && <span className="text-danger">&#9733;</span>}
            <span className="ms-1">{GetSvgIcon("ToolTip")} </span>
            <span className="form-label font-12 text-danger p-2" htmlFor="">
              Maxlength 10
            </span>
          </label>
          <input
            name={
              isArray
                ? `${key}.${secKey}.${index}.postcode`
                : `${key}.${secKey}.postcode`
            }
            className="form-control"
            type="number"
            {...register(
              isArray
                ? `${key}.${secKey}.${index}.postcode`
                : `${key}.${secKey}.postcode`,
              {
                required: {
                  value:
                    isRequired ||
                    watch(
                      isArray
                        ? `${key}.${secKey}.${index}.isChecked`
                        : `${key}.${secKey}.isChecked`
                    ) === true,
                  message: REQUIRED_ERR_MSG,
                },
                pattern: {
                  value: NUMBER_REGEX,
                  message: "Field accepts only numbers!!",
                },
                maxLength: {
                  value: 10,
                  message: "Maximun 10 characters allowed",
                },
              }
            )}
            disabled={
              watchOrdType === ORDER_TYPE.CHP ||
              watch(
                isArray
                  ? `${key}.${secKey}.${index}.isChecked`
                  : `${key}.${secKey}.isChecked`
              ) === false
            }
            maxLength={10}
            onWheel={(e) => numberInputOnWheelPreventChange(e)}
          />
          {(isArray && errors?.[key] && errors?.[key]?.[secKey]
            ? errors?.[key]?.[secKey][index]?.postcode
            : errors?.[key]?.[secKey]?.postcode) && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888;{" "}
                {isArray
                  ? errors?.[key]?.[secKey][index]?.postcode?.message
                  : errors?.[key]?.[secKey]?.postcode?.message}
              </span>
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <label className="form-label theme-label">
            Latitude
            {isRequired && <span className="text-danger">&#9733;</span>}
            <span className="ms-1">{GetSvgIcon("ToolTip")} </span>
            <span className="form-label font-12 text-danger p-2" htmlFor="">
              Value range from -90.00000 to 90.00000
            </span>
          </label>
          <input
            name={
              isArray
                ? `${key}.${secKey}.${index}.latitude`
                : `${key}.${secKey}.latitude`
            }
            className="form-control"
            type="number"
            disabled={true}
            {...register(
              isArray
                ? `${key}.${secKey}.${index}.latitude`
                : `${key}.${secKey}.latitude`,
              {
                required: {
                  value:
                    isRequired ||
                    watch(
                      isArray
                        ? `${key}.${secKey}.${index}.isChecked`
                        : `${key}.${secKey}.isChecked`
                    ) === true,
                  message: REQUIRED_ERR_MSG,
                },
                pattern: {
                  value: LATPATTERN_5,
                  message: LAT_ERR_MSG,
                },
              }
            )}
            onWheel={(e) => numberInputOnWheelPreventChange(e)}
          />
          {(isArray && errors?.[key] && errors?.[key]?.[secKey]
            ? errors?.[key]?.[secKey][index]?.latitude
            : errors?.[key]?.[secKey]?.latitude) && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888;{" "}
                {isArray
                  ? errors?.[key]?.[secKey][index]?.latitude?.message
                  : errors?.[key]?.[secKey]?.latitude?.message}
              </span>
            </div>
          )}
        </Col>
        <Col>
          <label className="form-label theme-label">
            Longitude
            {isRequired && <span className="text-danger">&#9733;</span>}
            <span className="ms-1">{GetSvgIcon("ToolTip")} </span>
            <span className="form-label font-12 text-danger p-2" htmlFor="">
              Value range from -180.00000 to 180.00000
            </span>
          </label>
          <input
            name={
              isArray
                ? `${key}.${secKey}.${index}.longitude`
                : `${key}.${secKey}.longitude`
            }
            className="form-control"
            type="number"
            disabled={true}
            {...register(
              isArray
                ? `${key}.${secKey}.${index}.longitude`
                : `${key}.${secKey}.longitude`,
              {
                required: {
                  value:
                    isRequired ||
                    watch(
                      isArray
                        ? `${key}.${secKey}.${index}.isChecked`
                        : `${key}.${secKey}.isChecked`
                    ) === true,
                  message: REQUIRED_ERR_MSG,
                },
                pattern: {
                  value: LONGPATTERN_5,
                  message: LONG_ERR_MSG,
                },
              }
            )}
            onWheel={(e) => numberInputOnWheelPreventChange(e)}
          />
          {(isArray && errors?.[key] && errors?.[key]?.[secKey]
            ? errors?.[key]?.[secKey][index]?.longitude
            : errors?.[key]?.[secKey]?.longitude) && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888;{" "}
                {isArray
                  ? errors?.[key]?.[secKey][index]?.longitude?.message
                  : errors?.[key]?.[secKey]?.longitude?.message}
              </span>
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <label className="form-label theme-label">Contact Name</label>
          {isRequired && <span className="text-danger">&#9733;</span>}
          <input
            name={
              isArray
                ? `${key}.${secKey}.${index}.name`
                : `${key}.${secKey}.name`
            }
            className="form-control"
            type="text"
            // disabled={watchOrdType === ORDER_TYPE.CHP}
            {...register(
              isArray
                ? `${key}.${secKey}.${index}.name`
                : `${key}.${secKey}.name`,
              {
                required: {
                  value:
                    isRequired ||
                    watch(
                      isArray
                        ? `${key}.${secKey}.${index}.isChecked`
                        : `${key}.${secKey}.isChecked`
                    ) === true,
                  message: REQUIRED_ERR_MSG,
                },
                pattern: {
                  value: NAME_REGEX,
                  message: "Enter Valid Name",
                },
              }
            )}
            disabled={
              watch(
                isArray
                  ? `${key}.${secKey}.${index}.isChecked`
                  : `${key}.${secKey}.isChecked`
              ) === false
            }
          />
          {(isArray && errors?.[key] && errors?.[key]?.[secKey]
            ? errors?.[key]?.[secKey][index]?.name
            : errors?.[key]?.[secKey]?.name) && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888;{" "}
                {isArray
                  ? errors?.[key]?.[secKey][index]?.name?.message
                  : errors?.[key]?.[secKey]?.name?.message}
              </span>
            </div>
          )}
        </Col>
        <Col>
          <label className="form-label theme-label">Contact Phone</label>
          {isRequired && <span className="text-danger">&#9733;</span>}
          <input
            name={
              isArray
                ? `${key}.${secKey}.${index}.phone`
                : `${key}.${secKey}.phone`
            }
            className="form-control"
            type="number"
            // disabled={watchOrdType === ORDER_TYPE.CHP}
            {...register(
              isArray
                ? `${key}.${secKey}.${index}.phone`
                : `${key}.${secKey}.phone`,
              {
                required: {
                  value:
                    isRequired ||
                    watch(
                      isArray
                        ? `${key}.${secKey}.${index}.isChecked`
                        : `${key}.${secKey}.isChecked`
                    ) === true,
                  message: REQUIRED_ERR_MSG,
                },
                pattern: {
                  value: PHONE_NUM,
                  message: "Enter Valid Contact No!!!",
                },
              }
            )}
            onWheel={(e) => numberInputOnWheelPreventChange(e)}
            disabled={
              watch(
                isArray
                  ? `${key}.${secKey}.${index}.isChecked`
                  : `${key}.${secKey}.isChecked`
              ) === false
            }
          />
          {(isArray && errors?.[key] && errors?.[key]?.[secKey]
            ? errors?.[key]?.[secKey][index]?.phone
            : errors?.[key]?.[secKey]?.phone) && (
            <div>
              <span className="text-danger fw-bold font-12">
                &#9888;{" "}
                {isArray
                  ? errors?.[key]?.[secKey][index]?.phone?.message
                  : errors?.[key]?.[secKey]?.phone?.message}
              </span>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );

  const getServiceLabel = (service) => {
    switch (service.serviceId) {
      case CH_SRVC_TYPE.WEIGHT:
      case CH_SRVC_TYPE.EXTRAMANPOWER:
        return service.serviceType;
      case CH_SRVC_TYPE.OTHERCHRG:
        return service.rateRefName;
      default:
        return "Service";
    }
  };

  const checkForMandatory = (service) => {
    switch (service.serviceId) {
      case CH_SRVC_TYPE.WEIGHT:
        return +watchRateType === CH_RATE_TYPE.WGT;
      case CH_SRVC_TYPE.VHCLTYPE:
        return +watchRateType === CH_RATE_TYPE.VT;
      default:
        return false;
    }
  };

  const checkForMinimum = (service) => {
    switch (service.serviceId) {
      case CH_SRVC_TYPE.WEIGHT:
        return +watchRateType === CH_RATE_TYPE.WGT &&
          +watchOrdType === ORDER_TYPE.CHA
          ? 1
          : 0;
      default:
        return 0;
    }
  };

  const serviceComponent = (service, index, key, argMD) => (
    <Col md={argMD} key={service?.id}>
      <label className="form-label theme-label">
        {getServiceLabel(service)}
      </label>
      <input
        type="number"
        className="form-control"
        name={`${key}.${index}.serviceValue`}
        {...register(`${key}.${index}.serviceValue`, {
          required: {
            value: checkForMandatory(service),
            message: REQUIRED_ERR_MSG,
          },
          min: {
            value: checkForMinimum(service),
            message: "Please enter value greater than 0",
          },
          max: {
            value:
              service.serviceId === CH_SRVC_TYPE.EXTRAMANPOWER
                ? 2
                : Number.MAX_SAFE_INTEGER,
            message: "Please enter value less than 2",
          },
          pattern: {
            value: NUMBER_NINE_DECIMAL,
            message: "Please enter only numeric values",
          },
        })}
        onWheel={(e) => numberInputOnWheelPreventChange(e)}
      />
      {!!errors?.rate && !!errors?.rate[index] && (
        <div className="ps-1">
          <span className="text-danger fw-bold font-12">
            &#9888; {errors?.rate[index]?.serviceValue?.message}
          </span>
        </div>
      )}
    </Col>
  );

  const tailgateComponent = (service, index) => (
    <Col md={4} key={service?.id}>
      <Row className=" mb-1 w-100">
        <Col md={4}>
          <label
            htmlFor=""
            className="form-label theme-label"
            title="This field is mandatory"
          >
            Tailgate{" "}
          </label>
        </Col>
      </Row>
      <Row className="w-100">
        <Col>
          <Toggler
            btnName="Tailgate-Book"
            isBtn1Checked={watch(`rate.${index}.isServiceEnabled`)}
            isBtn2Checked={!watch(`rate.${index}.isServiceEnabled`)}
            btn1Value={true}
            btn2Value={false}
            btn1Label="Yes"
            btn2Label="No"
            handler={(key, value) => toggleHandler(key, value, index)}
          />
        </Col>
      </Row>
    </Col>
  );

  const vhclTypeComponent = (
    <Col md={6}>
      <label
        htmlFor=""
        className="form-label theme-label"
        title="This field is mandatory"
      >
        Vehicle Type
        <span className="text-danger">&#9733;</span>
      </label>
      <div>
        <Controller
          name={`vhclType`}
          control={control}
          rules={{
            required: {
              value: checkForMandatory({ serviceId: CH_SRVC_TYPE.VHCLTYPE }),
              message: REQUIRED_ERR_MSG,
            },
            min: {
              value: +watchRateType === CH_RATE_TYPE.VT ? 1 : 0,
              message: REQUIRED_ERR_MSG,
            },
          }}
          render={({ field: { onChange, value } }) => (
            <Select
              placeholder="Select Vehicle Type"
              isSearchable={true}
              isClearable={true}
              className="form-control p-0"
              options={watch("vhclTypeOpts")}
              value={
                !!value
                  ? watch("vhclTypeOpts")?.find((opt) => opt.value === value)
                  : value
              }
              onChange={(opt) => {
                onChange(!!opt ? opt.value : 0);
                setValue("vhclTypeRate", opt);
              }}
            />
          )}
        />
        {errors?.vhclType && (
          <div className="ps-1">
            <span className="text-danger fw-bold font-12">
              &#9888; {errors?.vhclType?.message}
            </span>
          </div>
        )}
      </div>
    </Col>
  );

  const validatePieces = (data) => {
    if (
      +watchRateType === CH_RATE_TYPE.PCS &&
      watchOrdType === ORDER_TYPE.CHA
    ) {
      const val = data.rate
        .filter((rt) => rt.serviceId === CH_SRVC_TYPE.PIECES)
        .reduce((acc, curr) => acc + curr.serviceValue, 0);
      return val > 0;
    } else {
      return true;
    }
  };

  const handleServiceValueChange = (e, index) => {
    if (errors?.pieces) {
      clearErrors(`pieces`);
    }
  };

  const piecesComponent = rateArr.map((service, index) => (
    <>
      {service.serviceId === CH_SRVC_TYPE.PIECES && (
        <>
          <Col key={service?.id} md={3} className="pe-0">
            <label className="form-label theme-label me-2">
              {service.unitTypeText}{" "}
              {service.serviceUnitPrice > 0
                ? `(@ ${service.serviceUnitPrice} RM)`
                : ""}
            </label>
            <input
              className="form-control"
              name={`rate.${index}.serviceValue`}
              {...register(`rate.${index}.serviceValue`, {
                min: {
                  value: 0,
                  message: "Please check for negetive values",
                },
                pattern: {
                  value: NUMBER_NINE_DECIMAL,
                  message: "Please check for format: xxxxxxxxx.xx",
                },
              })}
              onChange={(e) => handleServiceValueChange(e, index)}
            />
            {!!errors?.rate && !!errors?.rate[index] && (
              <div className="ps-1">
                <span className="text-danger fw-bold font-12">
                  &#9888; {errors?.rate[index]?.serviceValue?.message}
                </span>
              </div>
            )}
          </Col>
        </>
      )}
    </>
  ));

  const renderRate = () => {
    switch (+watchRateType) {
      case CH_RATE_TYPE.WGT:
        setValue("vhclTypeRate", "");

        return (
          <>
            {rateArr.map(
              (rt, index) =>
                rt.serviceId === CH_SRVC_TYPE.WEIGHT &&
                serviceComponent(rt, index, "rate", 6)
            )}
          </>
        );
      case CH_RATE_TYPE.VT:
        return vhclTypeComponent;
      case CH_RATE_TYPE.PCS:
        return <Row className="px-3 mt-1">{piecesComponent}</Row>;
      default:
        return <></>;
    }
  };

  const otherServiceComponent = (service, index) => (
    <>
      {service.serviceUnitPrice > 0 && (
        <Col key={service.id} className="pe-0 d-flex">
          <label className="form-label theme-label text-wrap pe-2">
            {getServiceLabel(service)}
          </label>
          <Switch
            onToggle={setValue}
            keyCode={`rate.${index}.isServiceEnabled`}
            isOn={watch(`rate.${index}.isServiceEnabled`)}
            height={20}
            width={40}
          />
          {/* <Row>
            <Col md={4} className="pe-0 text-wrap text-break">
              <label className="form-label theme-label text-wrap">
                {getServiceLabel(service)}
              </label>
            </Col>
            <Col md={1} className="text-start ps-1">
              <Switch
                setValue={setValue}
                keyCode={`rate.${index}.isServiceEnabled`}
                isChecked={watch(`rate.${index}.isServiceEnabled`)}
              />
            </Col>
          </Row> */}
        </Col>
      )}
    </>
  );

  const toggleHandler = (key, value, index) => {
    setValue(`rate.${index}.isServiceEnabled`, value);
  };

  const navigateToPayment = () => {
    const copyPayData = summaryGetValues("paymentData");
    document.getElementById("paymentForm").innerHTML = getKiplForm(
      copyPayData.paymentGateway,
      copyPayData.shipmentId
    );
    document.getElementById("onlinepayment").submit();
  };

  const proceedForBooking = async () => {
    setSpinner(true);
    try {
      // Get booking payload
      const payload = summaryGetValues();

      payload.attachment = payload.attachment.filter((a) => !!a);
      payload.route.stops = payload.route.stops.filter(
        (st) => st.isChecked === true
      );
      const stopsArr = payload.route.stops.map((st) => st.stopSeq);
      // payload.useCredit = getValues("useCredit");

      if (watchOrdType === ORDER_TYPE.CHA) {
        payload.route.stops.forEach((st, index) => {
          let copyRate = Object.assign({}, initRateObj);
          copyRate.serviceInfo = `${st.stopSeq}`;
          copyRate.serviceId = CH_SRVC_TYPE.STOPCHG;
          copyRate.serviceValue = 1;
          payload.route.rate.targetRates.push(copyRate);
          payload.vas.push(copyRate);
        });
      } else {
        payload.route.rate.targetRates = payload.route.rate.targetRates.filter(
          (rt) =>
            rt.serviceId === 0 ||
            (rt.serviceId === CH_SRVC_TYPE.STOPCHG &&
              stopsArr.includes(+rt.serviceInfo))
        );
        payload.vas = payload.vas.filter(
          (v) =>
            v.serviceId !== CH_SRVC_TYPE.STOPCHG ||
            (v.serviceId === CH_SRVC_TYPE.STOPCHG &&
              stopsArr.includes(+v.serviceInfo))
        );
      }

      // Generate coordinates for distance calculation
      const stops = generateStops(payload);

      // Calculate distance
      if (watchOrdType === ORDER_TYPE.CHA) {
        const distanceResult = await calculateDistance(stops, {
          travelMode: "DRIVING",
          avoidFerries: true,
        });

        if (
          distanceResult.totalDistance !== null &&
          distanceResult.totalDistance >= 0
        ) {
          payload.orderInfos.push({
            infoCode: 171,
            infoValue: distanceResult.totalDistance,
          });
        }
      }

      // Make booking API call
      const bkngResp = await CallApiPost(API_URI.CH_BOOK, payload);

      if (
        bkngResp.respCode === 200 &&
        +bkngResp.respData?.shipmentBilling[0]?.invoiceId > 0 &&
        bkngResp.respData.paymentGateway
      ) {
        setTabIndex(3);
        summarySetValue("paymentData", bkngResp.respData);
      } else {
        const term = [0, 200].includes(bkngResp.respCode) ? "SCBKG" : "NOAXN";
        handleApiResponse(bkngResp, term);
      }
    } catch (error) {
      console.error("Booking process failed:", error);
      handleApiResponse({ respCode: 500, respMsg: error.message }, "NOAXN");
    } finally {
      setSpinner(false);
    }
  };

  const onSubmit = async (data) => {
    if (!checkNoBook()) {
      const usrType = +getUserInfo("userType");
      let payload = summaryGetValues();
      const paymentOpts = setPaymentType(payload);
      if (usrType === 134 && paymentOpts[0] === "CASH") {
        openAlert(
          false,
          "ERROR",
          "Your credit balance is too low to proceed with the booking."
        );
      } else {
        payload.paymentType =
          paymentOpts[0] === "CASH" && getValues("useCredit")
            ? "CASH&ADV"
            : paymentOpts[0];
        summarySetValue("paymentType", payload.paymentType);
        if (paymentOpts[1] === "CONT") {
          proceedForBooking();
        }
      }
    } else {
      openAlert(false, "ERROR", custCreditInfo?.ret_message);
    }
  };

  const onError = (err) => {
    console.error(err);
  };

  const checkNoBook = () => {
    return custCreditInfo?.status_code === "NOBK" ? true : false;
  };
  const setPaymentType = (data) => {
    if (
      +LINEHAUL_CUSTOMER_USER_TYPE_PERSONAL === custCreditInfo.cust_type ||
      !custCreditInfo?.is_credit
    ) {
      return ["CASH", "CONT"];
    } else {
      if (custCreditInfo?.status_code === "CRED") {
        return ["CREDIT", "CONT"];
      } else if (custCreditInfo?.status_code === "CASH") {
        openAlert(true, "", custCreditInfo?.ret_message, "BKNG");
        return ["CASH", "BKNG"];
      } else {
        if (custCreditInfo?.curr_credit_limit < data.totalAmt) {
          openAlert(true, "", "Switch to Cash Payment", "BKNG");
          return ["CASH", "BKNG"];
        } else {
          return ["CREDIT", "CONT"];
        }
      }
    }
  };
  const handelInsuranceSelect = (isChecked, id) => {
    //
    if (isChecked) {
      setValue("insurancePkgId", id);
      clearErrors("insAttch");
      clearErrors("insDeclaredPrice");
    } else {
      setValue("insurancePkgId", 0);
      setValue("insAttch", null);
      setValue("insDeclaredPrice", null);
      clearErrors("insAttch");
      clearErrors("insDeclaredPrice");
    }
  };

  const validateInsurance = (data) => {
    if (+watch("insurancePkgId") > 0) {
      if (+watch("insDeclaredPrice") > 0 && !!watch("insAttch")) {
        return true;
      } else {
        setError("insDeclaredPrice", {
          type: "required",
          message: REQUIRED_ERR_MSG,
          shouldFocus: true,
        });
        if ([null, undefined].includes(watch("insAttch"))) {
          setError("insAttch", {
            type: "required",
            message: REQUIRED_ERR_MSG,
            shouldFocus: true,
          });
        }

        return false;
      }
    } else {
      return true;
    }
  };

  const validateSpecialPermission = (data) => {
    const specialPickup = data.specialPickup;
    const specialDelivery = data.specialDelivery;

    let isValid = true;
    if (specialPickup === false && specialDelivery === false) {
      return true;
    } else {
      if (
        specialPickup === "true" &&
        [null, undefined].includes(data?.pickupInstUpload)
      ) {
        setError("pickupInstUpload", {
          type: "required",
          message: REQUIRED_ERR_MSG,
          shouldFocus: true,
        });
        isValid = false;
      }
      if (
        specialDelivery === "true" &&
        [null, undefined].includes(data?.dlvInstUpload)
      ) {
        setError("dlvInstUpload", {
          type: "required",
          message: REQUIRED_ERR_MSG,
          shouldFocus: true,
        });
        isValid = false;
      }
      return isValid;
    }
  };

  const setVhclTypeRate = (data, vas) => {
    const copyVhclTypeRate = data?.vhclTypeRate;
    if (!!copyVhclTypeRate && CH_RATE_TYPE.VT === data.route.rateType) {
      if (+copyVhclTypeRate?.rateId > 0) {
        vas.push(copyVhclTypeRate);
      } else {
        vas.push({
          rateId: 0,
          charges: 0,
          remarks: null,
          rateCode: "",
          unitType: 0,
          isUpdated: false,
          rateRefId: copyVhclTypeRate?.value,
          serviceId: CH_SRVC_TYPE.VHCLTYPE,
          rateRefName: copyVhclTypeRate?.label,
          serviceType: "Vehicle Type",
          serviceValue: 1,
          unitTypeText: null,
          correlationId: 0,
          serviceUnitPrice: 0,
        });
      }
    }
  };

  const processVas = (data, copyRateBase) => {
    let vas = [];
    data.rate.forEach((rt) => {
      switch (rt.serviceId) {
        case CH_SRVC_TYPE.TAILGATE:
        case CH_SRVC_TYPE.OTHERCHRG:
          if (rt.isServiceEnabled) {
            vas.push(rt);
          }
          break;
        case CH_SRVC_TYPE.PIECES:
          if (CH_RATE_TYPE.PCS === data.route.rateType) {
            vas.push(rt);
          }
          break;
        case CH_SRVC_TYPE.WEIGHT:
          if (CH_RATE_TYPE.WGT === data.route.rateType) {
            vas.push(rt);
          }
          break;
        case CH_SRVC_TYPE.VHCLTYPE:
          if (CH_RATE_TYPE.VT === data.route.rateType) {
          }
          break;
        default:
          vas.push(rt);
          break;
      }
    });
    setVhclTypeRate(data, vas);
    // if (!!getValues("vhclTypeRate")) {
    //   vas.push(getValues("vhclTypeRate"));
    // }

    vas = vas.concat(copyRateBase);
    data.vas = [...vas];
  };

  const generateStops = (data) => {
    let retStops = [];
    const copyRouteCode =
      data.orderType === ORDER_TYPE.CHP
        ? data.route.routeCode
        : `RT${moment().format("YYMMDDhhmm")}`;
    data.route.routeCode = copyRouteCode;
    data.route.origin.routeCode = copyRouteCode;
    retStops.push(data.route.origin);
    data.route.stops.forEach((stp, index) => {
      stp.routeCode = copyRouteCode;
      retStops.push(stp);
    });
    data.route.destination.routeCode = copyRouteCode;
    retStops.push(data.route.destination);
    data.route.stops = [...retStops];

    return data.route.stops.map((st) => ({
      latitude: st.latitude,
      longitude: st.longitude,
    }));
  };

  const processRoute = (data, copyRateBase) => {
    // let filteredStops = data.route.stops.filter(
    //   (st, index) =>
    //     JSON.stringify(st) !== JSON.stringify(initRouteData.stops[index]) &&
    //     validateAddressData(st) &&
    //     st.isChecked === true
    // );
    // data.route.stops = filteredStops;

    // data.route.customerId =
    //   +getValues("orderType") === ORDER_TYPE.CHA
    //     ? getUserInfo("customerId")
    //     : data.route.customerId;
    data.route.customerId =
      +getValues("orderType") === ORDER_TYPE.CHA
        ? getUserInfo("customerId")
        : navData?.navigateFor === CH_NAV_TYPE.SNB
        ? customerId
        : data.route.customerId;
    data.route.routeType =
      +getValues("orderType") === ORDER_TYPE.CHA
        ? ROUTE_TYPE.CH_ADHOC
        : data.route.routeType;
    data.route.rate = {
      userId: getUserInfo("userId"),
      operationType: 0,
      baseRates: [],
      targetRates: copyRateBase,
    };
  };

  const getPayloadForBilling = (argData) => {
    let payload = JSON.parse(JSON.stringify(argData));
    const stopsArr = payload.route.stops.reduce(
      (acc, curr) => (curr.isChecked === true ? [...acc, curr.stopSeq] : acc),
      []
    );
    if (watchOrdType === ORDER_TYPE.CHA) {
      payload.route.stops.forEach((st, index) => {
        if (st.isChecked === true) {
          let copyRate = Object.assign({}, initRateObj);
          copyRate.serviceInfo = `${st.stopSeq}`;
          copyRate.serviceId = CH_SRVC_TYPE.STOPCHG;
          copyRate.serviceValue = 1;
          payload.route.rate.targetRates.push(copyRate);
          payload.vas.push(copyRate);
        }
      });
    } else {
      payload.route.rate.targetRates = payload.route.rate.targetRates.filter(
        (rt) =>
          rt.serviceId === 0 ||
          (rt.serviceId === CH_SRVC_TYPE.STOPCHG &&
            stopsArr.includes(+rt.serviceInfo))
      );
      payload.vas = payload.vas.filter(
        (v) =>
          v.serviceId !== CH_SRVC_TYPE.STOPCHG ||
          (v.serviceId === CH_SRVC_TYPE.STOPCHG &&
            stopsArr.includes(+v.serviceInfo))
      );
    }
    return payload;
  };

  const onNext = async (data) => {
    if (data.rate) {
      data.rate.forEach((item) => {
        if (item.serviceValue) {
          // Convert string numbers to Number
          item.serviceValue = Number(item.serviceValue);
        }
      });
    }
    if (!validateInsurance(data)) {
      return;
    }
    if (!validateSpecialPermission(data)) {
      return;
    }
    if (!validatePieces(data)) {
      setError("pieces", {
        type: "required",
        message: "Please add atleast one pieces info",
        shouldFocus: true,
      });
      return;
    }

    data.rateType = data.route.rateType;
    const copyRateBase = Array.isArray(data.route.rateBase)
      ? data.route.rateBase
      : JSON.parse(data.route.rateBase);

    //data.customerId = getUserInfo("customerId");
    let custId;
    switch (navData?.navigateFor) {
      case CH_NAV_TYPE.SNB:
        custId = customerId;
        break;
      default:
        custId = getUserInfo("customerId");
    }
    data.customerId = custId;
    processRoute(data, copyRateBase);
    const stopSeqArr = data.route.stops.map((st) => st.stopSeq);
    stopSeqArr.push(99);
    processVas(data, copyRateBase);

    // data.itemInfo = data.itemInfo.filter((item) =>
    //   stopSeqArr.includes(item.stopSeq)
    // );
    data.attachment = [
      data.insAttch,
      data.pickupInstUpload,
      data.dlvInstUpload,
    ];

    let ordInfo = [];
    ordInfo.push(
      !!data.specialPickup
        ? {
            infoCode: INFO_CODE.SPCLPERM,
            infoValue: "pickup",
            fileName: data?.pickupInstUpload?.fileName,
          }
        : null
    );
    ordInfo.push(
      !!data.specialDelivery
        ? {
            infoCode: INFO_CODE.SPCLPERM,
            infoValue: "delivery",
            fileName: data?.dlvInstUpload?.fileName,
          }
        : null
    );
    data.orderInfos = data.orderInfos.concat(ordInfo.filter(Boolean));
    data.remark = cleanNewLine(data.remark);
    setSpinner(true);
    const billResp = await CallApiPost(
      "CalculateCharteredBilling",
      getPayloadForBilling(data)
    );
    if (billResp.respCode === 200) {
      data.shipmentBilling = billResp.respData.shipmentBilling;
      data.totalAmt = data.shipmentBilling.reduce(
        (accumulator, currentValue) =>
          accumulator + currentValue.totalBillAmount,
        0
      );
      data.sst = data.shipmentBilling.find(
        (bill) => bill.particularId === PARTICULAR.SST
      )?.taxAmount;
      data.totalAmt = data.totalAmt - (data.sst || 0);
      setTabIndex(1);
      summaryReset({ ...data });
    } else {
      data.shipmentBilling = [];
      handleApiResponse(billResp);
    }
    setSpinner(false);
  };

  const getBookBtnLabel = () => {
    return watchOrdType === ORDER_TYPE.CHA ? "ASK FOR QUOTATION" : "BOOK";
  };

  const contentDesc = (item, index) => (
    <Row className="mt-1">
      {/* <Col md={1}>
        <label className="form-label theme-label">
          {item.stopSeq === 99
            ? "Destination Items"
            : `Stop ${item.stopSeq} Items`}
        </label>
      </Col> */}
      <Col>
        <input
          type="text"
          placeholder="Enter Item Name"
          className="form-control"
          name={`orderInfos.${index}.infoValue`}
          {...register(`orderInfos.${index}.infoValue`, {
            required: {
              value: true,
              message: REQUIRED_ERR_MSG,
            },
            pattern: {
              value: TEXT_AREA_REGEX,
              message: "Please check for invalid characters",
            },
          })}
        />
        {!!errors?.orderInfos &&
          !!errors?.orderInfos[index] &&
          !!errors?.orderInfos[index]?.infoValue && (
            <div className="ps-1">
              <span className="text-danger fw-bold font-12">
                &#9888; {errors?.orderInfos[index]?.infoValue?.message}
              </span>
            </div>
          )}
      </Col>
      <Col>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Item Type"
          name={`orderInfos.${index}.infoType`}
          {...register(`orderInfos.${index}.infoType`, {
            required: {
              value: true,
              message: REQUIRED_ERR_MSG,
            },
            pattern: {
              value: TEXT_AREA_REGEX,
              message: "Please check for invalid characters",
            },
          })}
        />
        {!!errors?.orderInfos &&
          !!errors?.orderInfos[index] &&
          !!errors?.orderInfos[index]?.infoType && (
            <div className="ps-1">
              <span className="text-danger fw-bold font-12">
                &#9888; {errors?.orderInfos[index]?.infoType?.message}
              </span>
            </div>
          )}
      </Col>
      <Col>
        <input
          type="number"
          className="form-control"
          placeholder="Enter Item Quantity"
          name={`orderInfos.${index}.infoQuantity`}
          {...register(`orderInfos.${index}.infoQuantity`, {
            required: {
              value: true,
              message: REQUIRED_ERR_MSG,
            },
            min: {
              value: 1,
              message: "Acceptable minimum quantity is 1",
            },
            pattern: {
              value: TEXT_AREA_REGEX,
              message: "Please check for invalid characters",
            },
          })}
          onWheel={(e) => numberInputOnWheelPreventChange(e)}
        />
        {!!errors?.orderInfos &&
          !!errors?.orderInfos[index] &&
          !!errors?.orderInfos[index]?.infoQuantity && (
            <div className="ps-1">
              <span className="text-danger fw-bold font-12">
                &#9888; {errors?.orderInfos[index]?.infoQuantity?.message}
              </span>
            </div>
          )}
      </Col>

      <Col md={1} className="text-end">
        {index > 0 && (
          <label
            className="form-label theme-label"
            onClick={() => ordInfoRemove(index)}
          >
            {GetSvgIcon("DashCircleFill")}
          </label>
        )}
      </Col>
    </Row>
  );

  return (
    <div>
      <Layout
        spinnershow={spinner}
        alertConfig={alertConfig}
        hideAlert={hideAlert}
      >
        {/* <div className="clearfix d-flex justify-content-center mt-3 mb-1">
          <h1 className="header-text">{watchPageLabel}</h1>
        </div> */}
        {/* <div className="container-custom "> */}
        <section className="w-100 mb-4">
          <Row className="w-100">
            {tabIndex === 0 && navData.navigateFor === CH_NAV_TYPE.NB ? (
              <Col className="d-flex justify-content-center">
                <ButtonGroup className="mb-2 w-50">
                  <Button
                    variant={watchPrimary?.variant}
                    className={watchPrimary?.className}
                    onClick={() =>
                      onToggle(ORDER_TYPE.CHP, routes[0], stateCityOpt, rate)
                    }
                    disabled={tabIndex > 0}
                  >
                    {P_CHARTER}
                  </Button>
                  <Button
                    variant={watchSecondary?.variant}
                    className={watchSecondary?.className}
                    onClick={() =>
                      onToggle(
                        ORDER_TYPE.CHA,
                        initRouteData,
                        stateCityOpt,
                        rate
                      )
                    }
                    disabled={tabIndex > 0}
                  >
                    {A_CHARTER}
                  </Button>
                </ButtonGroup>
              </Col>
            ) : (
              <Col className="text-center">
                <h3 className="theme-violet-txt mb-0">
                  {watchOrdType === ORDER_TYPE.CHA ? A_CHARTER : P_CHARTER}
                </h3>
              </Col>
            )}
          </Row>
        </section>
        {tabIndex === 0 &&
          ((routes.length > 0 &&
            rate?.rateOpts.length > 0 &&
            +watchRateType > 0 &&
            +watchOrdType === ORDER_TYPE.CHP) ||
          watchOrdType === ORDER_TYPE.CHA ? (
            <>
              <Row>
                {watchOrdType === ORDER_TYPE.CHP && (
                  <Col md={3}>
                    <label className="form-label theme-label">
                      Route
                      <span className="text-danger">&#9733;</span>
                    </label>
                    <div>
                      <Controller
                        name={`route.id`}
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            placeholder="Select Route"
                            isSearchable={true}
                            // isClearable={true}
                            className="form-control p-0"
                            options={routes}
                            value={
                              !!value
                                ? routes?.find((opt) => opt.value === value)
                                : value
                            }
                            onChange={(opt) => {
                              // onChange(!!opt ? opt.value : 0)
                              setUpRouteData(!!opt ? opt : initRouteData);
                              if (!!opt && opt.id > 0) {
                                clearErrors("route.id");
                              } else {
                                setError(
                                  "route.id",
                                  { type: "focus", message: REQUIRED_ERR_MSG },
                                  { shouldFocus: true }
                                );
                              }
                            }}
                          />
                        )}
                      />
                      {errors?.route?.id && (
                        <div className="ps-1">
                          <span className="text-danger fw-bold font-12">
                            &#9888; {errors?.route?.id?.message}
                          </span>
                        </div>
                      )}
                    </div>
                  </Col>
                )}

                <Col md={3}>
                  <label className="form-label theme-label">
                    Pickup Date
                    <span className="text-danger">&#9733;</span>
                  </label>
                  <div>
                    <Controller
                      name="shipmentDate"
                      control={control}
                      rules={{
                        required: { value: true, message: REQUIRED_ERR_MSG },
                      }}
                      render={({ field: { onChange, value } }) => (
                        <ReactDatePicker
                          // showTimeInput
                          placeholderText="Pickup Date"
                          wrapperClassName="w-100"
                          className="form-control"
                          dateFormat={DATE_FORMAT_CLIENT}
                          minDate={new Date(bkngDateRange?.minChDate)}
                          maxDate={new Date(estDlvDt)}
                          selected={value ? new Date(value) : value}
                          onChange={(d) => {
                            onChange(
                              d !== null ? moment(d).format("YYYY-MM-DD") : ""
                            );
                            setValue(
                              "estDeliveryDate",
                              d !== null ? moment(d).format("YYYY-MM-DD") : ""
                            );
                          }}
                        />
                      )}
                    />
                    {errors?.shipmentDate && (
                      <div>
                        <span className="text-danger fw-bold font-12">
                          &#9888; {errors?.shipmentDate?.message}
                        </span>
                      </div>
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <label className="form-label theme-label">
                    Pickup Time
                    <span className="text-danger">&#9733;</span>
                  </label>
                  <div>
                    <input
                      type="time"
                      id="shipmentTime"
                      name="shipmentTime"
                      required
                      className="form-control"
                      {...register("shipmentTime", {
                        required: {
                          value: true,
                          message: REQUIRED_ERR_MSG,
                        },
                      })}
                    />
                    {errors?.shipmentTime && (
                      <div>
                        <span className="text-danger fw-bold font-12">
                          &#9888; {errors?.shipmentTime?.message}
                        </span>
                      </div>
                    )}
                  </div>
                </Col>
                <Col md={3}>
                  <label className="form-label theme-label">
                    Delivery Date
                    <span className="text-danger">&#9733;</span>
                  </label>
                  <div>
                    <Controller
                      name="estDeliveryDate"
                      control={control}
                      rules={{
                        required: { value: true, message: REQUIRED_ERR_MSG },
                      }}
                      render={({ field: { onChange, value } }) => (
                        <ReactDatePicker
                          // showTimeInput
                          placeholderText="Delivery Date"
                          wrapperClassName="w-100"
                          className="form-control"
                          dateFormat={DATE_FORMAT_CLIENT}
                          minDate={
                            new Date(
                              !!pickUpDt ? pickUpDt : bkngDateRange?.minChDate
                            )
                          }
                          // maxDate={new Date(bkngDateRange?.maxChDate)}
                          selected={value ? new Date(value) : value}
                          onChange={(d) =>
                            onChange(
                              d !== null ? moment(d).format("YYYY-MM-DD") : ""
                            )
                          }
                        />
                      )}
                    />
                    {errors?.estDeliveryDate && (
                      <div>
                        <span className="text-danger fw-bold font-12">
                          &#9888; {errors?.estDeliveryDate?.message}
                        </span>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col className=" mt-2">
                  {addrBlock(
                    addrLabel.org.pKey,
                    addrLabel.org.sKey,
                    addrLabel.org.label,
                    0,
                    0,
                    true,
                    false
                  )}
                </Col>
                <Col className=" mt-2">
                  {addrBlock(
                    addrLabel.dest.pKey,
                    addrLabel.dest.sKey,
                    addrLabel.dest.label,
                    99,
                    99,
                    true,
                    false
                  )}
                </Col>
              </Row>

              <Row className="mb-3">
                {!!watchStops &&
                  Array.isArray(watchStops) &&
                  watchStops.map(
                    (item, index) =>
                      (item.stopSeq !== 0 || item.stopSeq !== 99) && (
                        <Col key={item.stopSeq} md={6} className="mt-2">
                          {addrBlock(
                            `route`,
                            "stops",
                            "Stop " + item.stopSeq,
                            item.stopSeq,
                            index,
                            false,
                            true
                          )}
                        </Col>
                      )
                  )}
              </Row>
              <Row>
                <Col md={8}>
                  <Card className="bg-white border border-2 rounded-2">
                    <Card.Body className="p-2">
                      <Row>
                        {+watchRateType === 0 ||
                        watchRateTypeOpts?.some(
                          (rt) => rt.value === getValues("route.rateType")
                        ) ? (
                          <>
                            <Col md={6}>
                              <label className="form-label theme-label">
                                Rate Type
                                <span className="text-danger">&#9733;</span>
                              </label>
                              <div>
                                <Controller
                                  name={`route.rateType`}
                                  control={control}
                                  rules={{
                                    required: {
                                      value: true,
                                      message: REQUIRED_ERR_MSG,
                                    },
                                    min: {
                                      value: 1,
                                      message: REQUIRED_ERR_MSG,
                                    },
                                  }}
                                  render={({ field: { onChange, value } }) => (
                                    <Select
                                      placeholder="Select Rate"
                                      isSearchable={true}
                                      isClearable={true}
                                      isDisabled={
                                        +watchOrdType === ORDER_TYPE.CHP
                                      }
                                      wrapperClassName="w-100"
                                      className="form-control p-0"
                                      options={watchRateTypeOpts}
                                      value={
                                        !!value
                                          ? watchRateTypeOpts?.find(
                                              (opt) => opt.value === value
                                            )
                                          : value
                                      }
                                      onChange={(opt) => {
                                        onChange(!!opt ? opt.value : 0);
                                        if (errors?.pieces) {
                                          clearErrors(`pieces`);
                                        }
                                      }}
                                    />
                                  )}
                                />
                                {errors?.route?.rateType && (
                                  <div>
                                    <span className="text-danger fw-bold font-12">
                                      &#9888; {errors?.route?.rateType?.message}
                                    </span>
                                  </div>
                                )}
                                {errors?.pieces && (
                                  <div>
                                    <span className="text-danger fw-bold font-12">
                                      &#9888; {errors?.pieces?.message}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </Col>
                            {renderRate()}
                          </>
                        ) : (
                          <Col>
                            <center>
                              <h5 className="text-danger">
                                ** Rate not defined for this route **
                              </h5>
                            </center>
                          </Col>
                        )}
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
                <Col>
                  <Card className="bg-white border border-2 rounded-2">
                    <Card.Body className="p-2">
                      <Row>
                        {rateArr.map(
                          (rt, index) =>
                            rt.serviceId === CH_SRVC_TYPE.EXTRAMANPOWER &&
                            serviceComponent(rt, index, "rate", 8)
                        )}

                        {rateArr.map(
                          (rt, index) =>
                            rt.serviceId === CH_SRVC_TYPE.TAILGATE &&
                            tailgateComponent(rt, index, "rate")
                        )}
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Card className="bg-white border border-2 rounded-2 mt-3">
                <Card.Header className="p-1">
                  <div className="d-flex flex-row justify-content-between">
                    <span>
                      <label className="subheadingtext">ITEM DESCRIPTION</label>
                      <span className="text-danger">&#9733;</span>
                    </span>
                    <span>
                      <label
                        className="form-label theme-label pe-1"
                        onClick={() => ordInfoAppend(initItem)}
                      >
                        {GetSvgIcon("PlusCircle")}
                      </label>
                    </span>
                  </div>
                </Card.Header>
                <Card.Body className="p-2">
                  {orderInfos.map((item, index) => contentDesc(item, index))}
                </Card.Body>
              </Card>
              <Card className="bg-white border border-2 rounded-2 mt-3">
                <Card.Header className="subheadingtext p-1">
                  OTHER SERVICES
                </Card.Header>
                <Card.Body className="p-2">
                  <Row className="mt-1">
                    {rateArr.map(
                      (rt, index) =>
                        rt.serviceId === CH_SRVC_TYPE.OTHERCHRG &&
                        otherServiceComponent(rt, index)
                    )}
                  </Row>
                  <Row>
                    <Col>
                      <label className="form-label theme-label">Remarks</label>
                      <textarea
                        className="form-control"
                        {...register("remark")}
                      ></textarea>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <BookingInsurance
                insuranceData={insuranceData}
                selectedInsurance={+watch("insurancePkgId")}
                handelInsuranceSelect={handelInsuranceSelect}
                filterInsurance={() => {}}
                avalServices={avalServices}
                register={register}
                setValue={setValue}
                watch={watch}
                errors={errors}
                clearErrors={clearErrors}
              />
              <Row className="mt-3">
                <Col className="text-center">
                  <button
                    type="button"
                    className="btn btn-primary theme-violet"
                    onClick={handleSubmit(onNext, onError)}
                    disabled={
                      !watchRateTypeOpts?.some(
                        (rt) => rt.value === getValues("route.rateType")
                      )
                    }
                  >
                    NEXT
                  </button>
                </Col>
              </Row>
            </>
          ) : (
            <Row>
              {isLoaded && (
                <Col>
                  <p className="text-center fs-1 fw-bold text-danger">
                    Sorry there is no {routes.length <= 0 ? "route" : "rate"}{" "}
                    defined for you.
                  </p>
                  <p className="text-center fs-2 fw-bold text-danger">
                    Please opt for On-Demand Charter
                  </p>
                </Col>
              )}
            </Row>
          ))}{" "}
        {tabIndex === 1 && (
          <>
            <CharterOrderSummary
              getValues={summaryGetValues}
              setValue={setValue}
              watch={watch}
              rate={rate}
              insuranceData={insuranceData}
              custCreditInfo={custCreditInfo}
            />
            <Row className="mt-3">
              <Col className="text-center">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setTabIndex(0)}
                >
                  BACK
                </button>
                <button
                  type="button"
                  className="btn btn-primary theme-violet ms-1"
                  onClick={handleSubmit(onSubmit, onError)}
                >
                  {getBookBtnLabel()}
                </button>
              </Col>
            </Row>
          </>
        )}
        {tabIndex === 3 && (
          <div id="paymentForm">
            <div className="py-5">
              <center>
                <h3 className="text-danger">
                  Please Wait. Payment is in progress...
                </h3>
                <h5 className="text-danger">
                  Do not click any button or refresh the page.
                </h5>
              </center>
            </div>
          </div>
        )}
      </Layout>
      <LocateSBU
        showMap={showMap}
        setShowMap={setShowMap}
        data={[]}
        setter={handleLocationSelect}
      />
    </div>
  );
};

export default CharteredBooking;
